import FadeIn from "../ui/FadeIn";
import { SERVICES } from "../../data/constants";
import styles from "./Services.module.css";

export default function Services() {
  return (
    <section id="services" className={styles.section}>
      <div className="section-wrap">
        <FadeIn>
          <div className={styles.header}>
            <div className="sec-label">What We Offer</div>
            <h2 className="sec-title">Our Services</h2>
            <p className={styles.headerSub}>
              Hover each service to explore what we offer across all areas of
              travel and global mobility.
            </p>
          </div>
        </FadeIn>
      </div>

      <div className={styles.gridWrap}>
        <div className={styles.grid}>
          {SERVICES.map((service, i) => (
            <FadeIn key={service.title} delay={i * 0.06}>
              <div className={styles.card}>
                <img
                  className={styles.cardImg}
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                />
                <div className={styles.cardOverlay} />
                <div className={styles.cardBody}>
                  <div className={styles.cardIcon}>{service.icon}</div>
                  <div className={styles.cardLine} />
                  <h3 className={styles.cardTitle}>{service.title}</h3>
                  <p className={styles.cardDesc}>{service.desc}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
